import type { SearchResult } from '../types/search.types';

/** Reads whichever id field the result carries — business and consumer name theirs differently. */
export const getSearchResultId = (result: SearchResult) =>
    'commonConsumerId' in result ? result.commonConsumerId : result.businessEntityId;
